import React, { Component } from "react";
import axios from "axios";
import $ from "jquery";
import Headers from "../Layouts/Headers";
import { LabSidebar } from "../Layouts/LabSidebar";
import { MDBTableEditable } from "../_mdbcomponents/components/pro/TableEditable/TableEditable";
import { MDBCard } from "../_mdbcomponents/components/Card/Card";
import { MDBCardHeader } from "../_mdbcomponents/components/Card/CardHeader/CardHeader";
import { MDBDataTable } from "../_mdbcomponents/components/DataTable/DataTable";
import Loader from "../Layouts/Loader";
import { MDBCardBody } from "../_mdbcomponents/components/Card/CardBody/CardBody";

export class Serology extends Component {
  constructor(props) {
    super(props);

   

    const url = "";
    this.state = {
      seraso: "",
      serwidal: "",
      serhpylori: "",
      serbrucella: "",
      serrf: "",
      sercrp: "",
      serrprvdrl: "",
      serrvi: "",
      sertpha: "",
      serpsa: "",
      serhbsag: "",
      serhcv: "",
      sertoxopla: "",
      seresr: "",
      serhb: "",
      serhct: "",
      serwbc: "",
      serdc: "",
      sern: "",
      serl: "",
      serm: "",
      sere: "",
      serb: "",
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

    this.modal = true;
  }

  componentDidMount() {
    var rowNumber = this.state["rowNumber"];
    var tableRow =
      '<tr><td><input className="form-control" name="Year" onChange={this.handleChange} value={Year}  type="text" required/> </td><td><textarea className="form-control" name="EvolutionPreviousPregnancy" onChange={this.handleChange} value={EvolutionPreviousPregnancy}></textarea></td><td><textarea className="form-control" name="InfantWeight" onChange={this.handleChange} value={InfantWeight}></textarea></td><td><textarea className="form-control" name="Sex" onChange={this.handleChange} value={Sex}></textarea></td> <td><textarea className="form-control" name="ModeDeliveryMode" onChange={this.handleChange} value={ModeDeliveryMode}></textarea></td><td><textarea className="form-control" name="InfantWeight" onChange={this.handleChange} value={InfantWeight}></textarea></td></tr>';
    $(".add-row").on("click", function () {
      $(".tableBody").append(tableRow);
    });
    this.setState({ rowNumber: parseInt(rowNumber) + 1 });
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  onTableChange(event) {}

  handleSubmit = (event) => {
    const headers = {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      token: localStorage.getItem("accessToken"),
      visitid: localStorage.getItem("currentVisitId"),
    };

    event.preventDefault();
    console.log(localStorage.getItem("objectLength"));
    var objectLength = localStorage.getItem("objectLength");

    this.setState({
      Year: this.state.tablevaluesglobal[0]["Year"],
    });

    console.log(this.state);

    for (var i = 0; i < Object.keys(this.state.tablevaluesglobal).length; i++) {
      // console.log(this.state.tablevaluesglobal[i]['Year'])

      var year = this.state.tablevaluesglobal[i]["Year"];
      var dict = {
        seraso: this.state.tablevaluesglobal[i]["seraso"],
        serwidal: this.state.tablevaluesglobal[i]["serwidal"],
        serhpylori: this.state.tablevaluesglobal[i]["serhpylori"],
        serbrucella: this.state.tablevaluesglobal[i]["serbrucella"],
        serrf: this.state.tablevaluesglobal[i]["serrf"],
        sercrp: this.state.tablevaluesglobal[i]["sercrp"],
        serrprvdrl: this.state.tablevaluesglobal[i]["serrprvdrl"],
        serrvi: this.state.tablevaluesglobal[i]["serrvi"],
        sertpha: this.state.tablevaluesglobal[i]["sertpha"],
        serpsa: this.state.tablevaluesglobal[i]["serpsa"],
        serhbsag: this.state.tablevaluesglobal[i]["serhbsag"],
        serhcv: this.state.tablevaluesglobal[i]["serhcv"],
        sertoxopla: this.state.tablevaluesglobal[i]["sertoxopla"],
        seresr: this.state.tablevaluesglobal[i]["seresr"],
        serhb: this.state.tablevaluesglobal[i]["serhb"],
        serhct: this.state.tablevaluesglobal[i]["serhct"],
        serwbc: this.state.tablevaluesglobal[i]["serwbc"],
        serdc: this.state.tablevaluesglobal[i]["serdc"],
        sern: this.state.tablevaluesglobal[i]["sern"],
        serl: this.state.tablevaluesglobal[i]["serl"],
        serm: this.state.tablevaluesglobal[i]["serm"],
        sere: this.state.tablevaluesglobal[i]["sere"],
        serb: this.state.tablevaluesglobal[i]["serb"],
      };

      axios
        .post(
          this.api_url+"laboratory/tests/Serology",
          dict,
          {
            headers: headers,
          }
        )
        .then((response) => {
          console.log(response);
          // /triage/antenatal/history

          if (response.data["status"]) {
            $(".alert-success").show();
            setTimeout(function () {
              // window.location.href = '/gynecology2/antenatal/history'
            }, 500);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  handleTableChange(event) {
    // console.log(event);
    // this.setState({ myParentTrigger: this.state.myParentTrigger + 'a' });
  }

  formatTableOutput(data) {
    let topobj = {};
    let tableobj = {};
    for (let i = 0; i < data.length; i++) {
      let trim = data[i];
      let trimobj = {};
      this.setState({
        Year: "1212",
      });

      trimobj.seraso = data[i][0];
      trimobj.serwidal = data[i][1];
      trimobj.serhpylori = data[i][2];
      trimobj.serbrucella = data[i][3];
      trimobj.serrf = data[i][4];
      trimobj.sercrp = data[i][5];
      trimobj.serrprvdrl = data[i][6];
      trimobj.serrvi = data[i][7];
      trimobj.sertpha = data[i][8];
      trimobj.serpsa = data[i][9];
      trimobj.serhbsag = data[i][10];
      trimobj.serhcv = data[i][11];
      trimobj.sertoxopla = data[i][12];
      trimobj.seresr = data[i][13];
      trimobj.serhb = data[i][14];
      trimobj.serhct = data[i][15];
      trimobj.serwbc = data[i][16];
      trimobj.serdc = data[i][17];
      trimobj.sern = data[i][18];
      trimobj.serl = data[i][19];
      trimobj.serm = data[i][20];
      trimobj.sere = data[i][21];
      trimobj.serb = data[i][22];
      tableobj[i] = trimobj;
      topobj.prepplan = tableobj;
    }
    this.state.tablevaluesglobal = topobj["prepplan"];
  }

  getTableValues(event) {
    let tablevalues = this.formatTableOutput(event);
    console.log(tablevalues);
  }

  render() {
    //Editable table variables
    const data = [
      [
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
      ],
    ];

    const columns = [
      "seraso",
      "serwidal",
      "serhpylori",
      "serbrucella",
      "serrf",
      "sercrp",
      "serrprvdrl",
      "serrvi",
      "sertpha",
      "serpsa",
      "serhbsag",
      "serhcv",
      "sertoxopla",
      "seresr",
      "serhb",
      "serhct",
      "serwbc",
      "serdc",
      "sern",
      "serl",
      "serm",
      "sere",
      "serb",
    ];

    const font16 = { fontSize: "16px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right;" };
    const floatLeft = { float: "left;" };
    const displayHidden = { display: "none" };

    return (
      <div>
        <Headers />
        <LabSidebar />
        <main className="content-container">
          <div className="container p-2">
            <form onSubmit={this.handleSubmit}>
              <div className="col-md-4 text-lg-center font-weight-bold p-1">
                <p className="text-capitalize" style={font16}></p>
              </div>
              <MDBCard>
                <MDBCardHeader
                  tag="h3"
                  className="text-center font-weight-bold text-capitalise py-4"
                >
                  Serology
                </MDBCardHeader>
                <MDBCardBody>
                  <MDBTableEditable
                    onChange={(value) => this.handleTableChange(value)}
                    getValue={(value) => this.getTableValues(value)}
                    myParentTrigger={this.state.myParentTrigger}
                    id="editablecard"
                    data={data}
                    columns={columns}
                    striped
                    bordered
                  />
                </MDBCardBody>
              </MDBCard>

              <div
                id="loginSuccess"
                className="alert alert-success"
                style={displayHidden}
                role="alert"
              >
                <strong>Success! </strong>Details Saved Successfully.
              </div>
              <div className="row">
                {/* <div style={displayHidden} className="col col-6"><button className="btn btn-primary btn-warning rounded-pill px-4 font-weight-bold" type="button" style={floatRight}>Send To Triage</button></div> */}
                <div className="col col-6">
                  <button
                    className="btn btn-primary btn-warning rounded-pill px-5 font-weight-bold"
                    type="submit"
                    style={floatLeft}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </form>
          </div>
        </main>
      </div>
    );
  }
}

export default Serology;
